import { capitalize } from "neetocist";
import withT from "neetocommons/react-utils/withT";
import { Switch, Tooltip } from "neetoui";

const TooltipSwitch = withT(
  ({
    t,
    enabledClientApps,
    widget,
    selectedWidgets,
    updateSelectedWidgets,
  }) => (
    <Tooltip
      disabled={enabledClientApps.includes(widget)}
      placement="right"
      content={t("neetoMolecules.widget.tooltips.productIsDisabled", {
        productName: `Neeto${capitalize(widget)}`,
      })}
    >
      <Switch
        checked={selectedWidgets.includes(widget)}
        disabled={!enabledClientApps.includes(widget)}
        onChange={() => updateSelectedWidgets(widget)}
      />
    </Tooltip>
  )
);

export default TooltipSwitch;
